import { BasicCollapsible, Box, Column, Divider, FlexBox, GridContainer, Progress, ProgressBarContainer, Row } from '@vp/swan'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { usePageFlow } from '../../context/page-flow-context'
import { useTracking } from '../../hooks/use-tracking'
import { PageSidebar } from '../sidebar/page-sidebar'

export const PageContent = () => {
  const { t } = useTranslation()
  const { StepComponent, currentStepIndex, visibleStepCount, isConfirmationStep, channel } = usePageFlow()
  const { trackPageView } = useTracking()
  const progressValue = Math.min(currentStepIndex + 1, visibleStepCount)

  useEffect(() => {
    trackPageView()
  }, [trackPageView, currentStepIndex])

  return (
    <GridContainer pt={{ xs: 7, sm: 9 }} pb={9} px={{ xs: 5, sm: 8 }}>
      <Row>
        <Column span={1} />
        <Column span={3}>
          <Box display={{ sm: 'none' }}>
            <BasicCollapsible heading={t('contact_us.page.sidebar.title')} headingLevel="h2">
              <PageSidebar channel={channel} />
            </BasicCollapsible>
            <Divider mb="between-sections" />
          </Box>
          <Box display={{ xs: 'none', sm: 'block' }}>
            <PageSidebar channel={channel} />
          </Box>
        </Column>
        <Column span={1} />
        <Column span={6} style={{ maxWidth: '664px' }}>
          <FlexBox flexDirection="column" gap={6}>
            {!isConfirmationStep && (
              <ProgressBarContainer style={{ maxWidth: '320px' }}>
                <Progress value={progressValue} max={visibleStepCount} aria-label={t('contact_us.page.progress_bar_label')} />
              </ProgressBarContainer>
            )}
            <StepComponent />
          </FlexBox>
        </Column>
        <Column span={1} />
      </Row>
    </GridContainer>
  )
}
